import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../libs/shared/helpers/src/internationalization/react';
import {FrontEvent, Handler, HandlerOf} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {IconButton} from '../../../../../libs/shared/ui/src/components/buttons/iconButton';
import {Dropdown, DropdownProps} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdown';
import {
  DropdownHeader,
  DropdownHeaderProps,
} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdownHeader';
import {DropdownList} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdownList';
import {fontSizes, fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';
import noSchedulingLinks from '../../../../assets/images/noSchedulingLinks.svg';
import {schedulingLearnMoreInlineLinkButton} from '../../../calendars/scheduling/schedulingLinkViewHelpers';
import {DropdownCategory} from '../../../common/dropdowns/dropdownCategory';
import {DropdownEmpty} from '../../../common/dropdowns/dropdownEmpty';
import {DropdownItemSeparator} from '../../../common/dropdowns/dropdownItemSeparator';
import {AddSchedulingLinkDropdownItem} from './addSchedulingLinkDropdownItem';

/*
 * Props.
 */

interface SchedulingLinksEmptyDropdownProps extends DropdownProps, DropdownHeaderProps {
  backButtonLabel: ReactNode;
  onBackButtonClick: Handler;
  onAddSchedulingLinkClick: HandlerOf<FrontEvent>;
}

/*
 * Style.
 */

const StyledEmptySchedulingLinksWrapperDiv = styled.div`
  text-align: center;
  padding: 0px 20px;
  line-height: 20px;
  color: ${(p) => p.theme.greys.shade70};
  font-size: ${fontSizes.small};
  font-weight: ${fontWeights.semibold};
`;

/*
 * Component.
 */

export const SchedulingLinksEmptyDropdown: FC<SchedulingLinksEmptyDropdownProps> = (props) => {
  const {title, onAddSchedulingLinkClick, ...dropdownProps} = props;
  return (
    <Dropdown {...dropdownProps}>
      <DropdownHeader title={title} leftIcon={renderBackButton(props)} />
      <DropdownList {...dropdownProps}>
        <DropdownCategory>
          <Trans id="dropdown-schedulinglinks-section-create">Create</Trans>
        </DropdownCategory>
        <AddSchedulingLinkDropdownItem onSelect={onAddSchedulingLinkClick} index={0} />
        <DropdownItemSeparator />
        <DropdownEmpty imageSource={noSchedulingLinks}>
          <StyledEmptySchedulingLinksWrapperDiv>
            <Trans id="dropdown-schedulinglinks-empty-title">
              Schedule meetings faster by creating a scheduling link.
            </Trans>
            &nbsp;
            {schedulingLearnMoreInlineLinkButton}
          </StyledEmptySchedulingLinksWrapperDiv>
        </DropdownEmpty>
      </DropdownList>
    </Dropdown>
  );
};

function renderBackButton(props: SchedulingLinksEmptyDropdownProps) {
  return (
    <IconButton iconName="chevronLeftSmall" label={props.backButtonLabel} onClick={props.onBackButtonClick} />
  );
}
